import { Fragment } from "react";
import { PageNavbar } from "../account";
import { Container } from "@/components/container";
import { useLayout } from "@/providers";
import {
  Toolbar,
  ToolbarDescription,
  ToolbarHeading,
  ToolbarPageTitle,
} from "@/partials/toolbar";
import ExternalServices from "./ExternalServices";
import { usePermissions } from "@/hooks/usePermissions";

const ExternalServiceManagement = () => {
  const { currentLayout } = useLayout();
  const { hasPermission } = usePermissions();

  if (!hasPermission("third_party_integration_configure")) {
    return (
      <Fragment>
        <PageNavbar />
        {currentLayout?.name === "demo1-layout" && (
          <Container>
            <Toolbar>
              <ToolbarHeading>
                <ToolbarPageTitle />
                <ToolbarDescription>
                  You can manage external services here.
                </ToolbarDescription>
              </ToolbarHeading>
            </Toolbar>
            <div className="mt-6">
              <div className="card card-grid min-w-full">
                <div className="card-body">
                  <div className="text-center py-4 text-gray-500">
                    You don't have permission to manage external services.
                  </div>
                </div>
              </div>
            </div>
          </Container>
        )}
      </Fragment>
    );
  }

  return (
    <Fragment>
      <PageNavbar />
      {currentLayout?.name === "demo1-layout" && (
        <Container>
          <Toolbar>
            <ToolbarHeading>
              <ToolbarPageTitle id="external-service-management-heading" />
              <ToolbarDescription>
                You can manage external services here.
              </ToolbarDescription>
            </ToolbarHeading>
          </Toolbar>
          <div className="mt-6">
            <ExternalServices />
          </div>
        </Container>
      )}
    </Fragment>
  );
};

export { ExternalServiceManagement };
